export default __webpack_public_path__ + "static/DSC_0094-710e3ea22a053deeafdec451b7b0aca5.jpg";